"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ICustomerConfiguration } from "@/interfaces/customer-configuration.interface";
import customerConfigurationService from "@/services/customer-configuration.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<ICustomerConfiguration> | null>;

type GetAllSwrParams = [string, number, number];

const useGetAllCustomerConfigurations = ({ pageNumber, pageSize }: RequestPagination): Return => {
  const fetcher = useSWR<PaginatedResponse<ICustomerConfiguration>, Error, GetAllSwrParams>(
    [SWR_KEYS.getAllCustomerConfigurations, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      customerConfigurationService.getAll({
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    { revalidateOnFocus: false }
  );

  const { data = null, isLoading: isInitialLoading, error } = fetcher;

  return { data, isLoading: isInitialLoading && !data, error };
};

export default useGetAllCustomerConfigurations;
